<div class="changelog-dialog">
  <div class="dialog-header">
    <h2>{{ title }}</h2>
    @if (subtitle) {
      <p class="subtitle">{{ subtitle }}</p>
    }
  </div>

  <div class="dialog-content">
    <app-data-table
      [columns]="columns"
      [data]="records"
      [loading]="loading"
      [alternateRowColors]="alternateRowColors">
    </app-data-table>
  </div>

  <div class="dialog-footer">
    <button (click)="close()">
      <mat-icon>arrow_back</mat-icon>
      {{ backButtonText }}
    </button>
  </div>
</div>

